"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAlert = void 0;
const faker_1 = require("@faker-js/faker");
const options_1 = __importDefault(require("../../data/options"));
const utils_1 = require("../../utils");
const generateAlert = (options) => {
    let date = faker_1.faker.date.recent({ days: 1, refDate: options?.createdRef });
    if (options?.start && options?.end && !options.createdRef) {
        date = faker_1.faker.date.between({ from: options.start, to: options.end });
    }
    const equipments = (options?.equipment || (0, utils_1.generateEquipment)()).split(' ');
    const singleEquipment = equipments[(0, utils_1.between)(equipments.length - 1)];
    const errorType = (0, utils_1.shuffle)(options_1.default.errorTypes);
    const message = `${singleEquipment} - ${errorType}`;
    const adverb = faker_1.faker.word.adverb();
    const hhmmss = date.toTimeString().split(' ')[0];
    const longMessage = `${singleEquipment} ${adverb} ${errorType.toLowerCase()} at ${hhmmss}`;
    return {
        id: faker_1.faker.string.uuid(),
        type: 'alert',
        contactRefId: options?.contactRefId || '',
        category: (0, utils_1.shuffle)(options_1.default.categories),
        expanded: false,
        longMessage,
        message,
        acknowledged: false,
        new: false,
        selected: false,
        timestamp: date.getTime(),
        status: (0, utils_1.shuffle)(options_1.default.statuses),
    };
};
exports.generateAlert = generateAlert;
